import Logger from "./Logger";
import CryptoJS from 'crypto-js';

/** 로딩 테스트를 위해서 사용한다. */
export const welcome = function (msg: string): boolean {
    Logger.info(`welcome ${msg}!`);
    return true;
};

export const createForm = function (parent: Element, target: string, name: string, action: string, method = 'POST') {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.setAttribute('target', target);
    form.setAttribute('method', method);
    form.setAttribute('action', action);
    form.setAttribute('name', name);
    parent.appendChild(form);
    return form;
};

export const createIframe = function (parent: Element, name: string) {
    const cyrexIframe = document.createElement('iframe');
    parent.appendChild(cyrexIframe);
    cyrexIframe.name = name;
    return cyrexIframe;
}

export const appendInput = function (form: Element, name: string, value: string) {
    try {
        const input = document.createElement('input');
        input.name = name;
        input.value = value;
        form.appendChild(input);
    } catch (error) {
        Logger.warn(error);
    }
};

export const setStyle = function (elem: Element, key: string, value: string) {
    try {
        const htmlElem = elem as HTMLElement;
        if(htmlElem.style) {
            htmlElem.style.setProperty(key, value);
        }
    } catch (error) {
        Logger.warn(error);
    }
};

export const equalsIgnoreCase = function (text: string, target: string | string[]) {
    if (!text) return false;
    if(typeof target == 'string') {
        return text.toLowerCase() == target.toLowerCase();
    } else {
        for(const each of target) {
            if(text.toLowerCase() == each.toLowerCase()) {
                return true;
            }
        }
        return false;
    }
}
export const equals = function (text: string, target: string | string[]) {
    if (!text) return false;
    if(typeof target == 'string') {
        return text == target;
    } else {
        for(const each of target) {
            if(text == each) {
                return true;
            }
        }
        return false;
    }
}

export const includes = function (text: string, target: string | string[]) {
    if (!text) return false;
    if(typeof target == 'string') {
        return text.includes(target);
    } else {
        for(const each of target) {
            if(text.includes(each)) {
                return true;
            }
        }
        return false;
    }
}

export const startsWith = function (text: string, target: string) {
    if (!text) return false;
    return text.startsWith(target);
}

export const formToJson = function (form: HTMLFormElement): string {
    const formData = new FormData(form);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return JSON.stringify(Object.fromEntries(Object.entries(formData).filter(([k]) => isNaN(k as any))));
}

export const getServerMode = function (dom: Document, scriptName: string, forceMode?: string) {
    let mode = 'prod';
    try {
        if(forceMode) {
            Logger.info(`getServerMode forceMode: ${forceMode}`);
            mode = forceMode;
        } else {
            const scriptElems = dom.querySelectorAll(`[src*=${scriptName}]`);
            if(scriptElems) {
                scriptElems.forEach(scElem => {
                    let src = scElem.getAttribute('src');
                    if(src == null) {
                        Logger.warn('getServerMode not found script');
                        mode = 'prod';
                    } else if (src.includes('://dapi.')) {
                        mode = 'sandbox';
                    } else if (src.includes('://tapi.')) {
                        mode = 'dev';
                    } else if (src.includes('://api.')) {
                        mode = 'prod';
                    } else if (src.includes('://localhost') || src.includes('://tc')) {
                        mode = 'local';
                    } else {
                        mode = 'local';
                    }
                })
            }
        }
    } catch (error) {
        Logger.warn(error);
        Logger.warn('getServerMode not found script');
    }
    Logger.info(`getServerMode result MODE: ${mode}`);
    return mode;
}

export const parseHTML = (org) => {
    if(org.indexOf('script') > -1 || org.indexOf('location.href') > -1) {
        // eslint-disable-next-line no-console
        console.log('xss note on parseHTML = ', org);
        return '';
    }
    let dest = org;
    dest = dest.replaceAll('&lt;', '<');
    dest = dest.replaceAll('&gt;', '>');
    dest = dest.replaceAll('"', '');
    dest = dest.replaceAll('`', '');
    dest = dest.replaceAll('\'', '');
    return dest;

}

export const encryptObject = (targetObject, key): string => {
    let encrypted = '';
    try {
        if(!targetObject) return encrypted;
        encrypted = window.btoa(CryptoJS.AES.encrypt(JSON.stringify(targetObject), key).toString());
    } catch (error) {
        Logger.exception('encryptObject exception', error);
        encrypted = '';
    }
    return encrypted;
}

export const initLogger = (host, defineMode) => {
    if(defineMode) {
        Logger.init(defineMode);
    } else if(host.startsWith('https://api.')) {
        Logger.init('prod');
    } else if(host.startsWith('https://dapi.')) {
        Logger.init('sandbox');
    } else if(host.startsWith('https://tapi.')) {
        Logger.init('dev');
    } else {
        Logger.init('local');
    }
}

export const isFail = (result) => {
    return result == null || result.resultCd == null || (result.resultCd != '0000' && result.resultCd != 'SUCCESS');
}

